@if (!hideAppHeader()) {
<header class="app-header">
  @if (isNavigating()) {
    <div class="nav-progress" role="progressbar" aria-label="Loading"></div>
  }
  <div class="app-header-inner">
    <a class="brand-mark" routerLink="/releases">
      <span class="logo" aria-hidden="true">
        <svg viewBox="0 0 64 64" width="28" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M32 8 L52.78 20 L52.78 44 L32 56 L11.22 44 L11.22 20 Z"
            stroke="#ffffff"
            stroke-width="4.5"
            stroke-linejoin="round"
          />
          <path
            d="M21 33 L28 40 L45 21"
            stroke="#8fe3b4"
            stroke-width="5.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span>TestHub</span>
    </a>

    <app-release-switcher />

    <div class="header-spacer"></div>

    @if (authService.isAuthenticatedSig() && authService.isAuthorizedSig()) {
      <div class="header-actions">
        <app-user-menu />
      </div>
    }
  </div>
</header>
}

<router-outlet />
